import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Stack } from '../Layout';
import { theme } from '../theme';
import { useHint } from './Hint';
import { Text } from './Text';
export const LabelText = styled(Text)``;
export const levelToIconSizeMap = {
    xs: 'xxxs',
    sm13: 'xxs',
    sm: 'xs',
    xl: 'xs'
};
export const LabelWithHint = ({ children, hint, level = 'sm', tone = theme.colors.grey500, ...restProps })=>{
    const _hint = useHint({
        hint,
        level,
        tone
    });
    return /*#__PURE__*/ _jsx(LabelText, {
        level: level,
        ...restProps,
        children: /*#__PURE__*/ _jsxs(Stack, {
            direction: "horizontal",
            gap: theme.spaces.x8,
            alignY: "center",
            children: [
                children,
                _hint
            ]
        })
    });
};
